<template>
  <!-- 携带物品 -->
  <div v-if="isEdit || list.length > 0" class="font-[Cubic]">
    <div class="mx-4 flex items-center red-dot justify-between">
      <div class="font-bold">{{ $t(`mission.carryItems.title`) }}</div>

      <button
        class="btn btn-xs btn-outline"
        v-if="isEdit"
        @click="showEquipmentSelectModal = true"
      >
        {{ $t(`mission.equipment.select`) }}
      </button>
      <!-- <span class="text-xs font-normal text-base-content/60 ml-auto">
        {{ $t(`mission.carryItems.maxTips`, { count: 5 }) }}
      </span> -->
    </div>
    <!-- 物品列表 -->
    <div class="px-4 flex gap-2 overflow-x-auto pt-2" v-if="list.length > 0">
      <div
        v-for="item in list"
        :key="item.id"
        :class="['flex flex-col items-center relative equipment-item']"
        @click.stop="clickEquipmentInfo(item)"
      >
        <div class="w-10 h-10 rounded-md border">
          <EquipmentIcon :equipment="item" />
        </div>
      </div>
    </div>

    <EquipmentDetailModal
      v-model:show="showEquipmentModal"
      :equipment="equipmentInfo"
      mode="view"
      @select="clickSelect"
    />
    <EquipmentSelectModal
      v-model:show="showEquipmentSelectModal"
      :select-ids="props.dispatchMission.carriedEquipmentzz?.map((v) => v.id)"
      @confirm="clickConfirm"
      :max-count="props.dispatchMission.type === DispatchType.Mission ? 5 : 1"
    />
  </div>
</template>

<script setup lang="ts">
import { MateDispatch, MateEquipment } from "@/types/entity";
import { computed, ref } from "vue";
import EquipmentSelectModal from "./EquipmentSelectModal.vue";
import { DispatchType } from "@/enums/mission";

const props = defineProps<{
  dispatchMission: Partial<MateDispatch>;
  isEdit: boolean;
}>();

const list = computed(() => {
  return props.dispatchMission.carriedEquipmentzz || [];
});

const showEquipmentModal = ref(false);
const equipmentInfo = ref<MateEquipment>({} as MateEquipment);

const clickEquipmentInfo = (item: MateEquipment) => {
  equipmentInfo.value = item;
  showEquipmentModal.value = true;
};

const showEquipmentSelectModal = ref(false);

const clickSelect = () => {
  showEquipmentModal.value = false;
};

const clickConfirm = (selectEquipments: MateEquipment[]) => {
  const dispatchMission = props.dispatchMission;
  dispatchMission.carriedEquipmentzz = selectEquipments;
  showEquipmentSelectModal.value = false;
};
</script>
